import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Text from "components/common/Text/Text";
import * as React from "react";
import Image from "react-image";
import styled from "styled-components";
import { getVendorImageUrl } from "utils/ConfigLoader";
interface IProps {
  vendorId?: string | null;
  locationName: string;
}

const HeroImage = styled(Image)`
  display: block;
  max-height: 200px;
  max-width: 400px;
  margin-right: auto;
  margin-left: auto;
  margin-top: -7vh;
`;

const VendorLogo = ({ vendorId, locationName }: IProps) => (
  <HeroImage
    src={[vendorId && getVendorImageUrl(vendorId)]}
    loader={<FontAwesomeIcon icon="spinner" size="3x" spin />}
    unloader={
      <Text h2 center fullWidth>
        {locationName}
      </Text>
    }
  />
);

export default VendorLogo;



// WEBPACK FOOTER //
// ./src/screens/Onboarding/WelcomeBoard/VendorLogo/VendorLogo.tsx